import { FRONT_ENV } from '@/_config/env';
import styles from './styles.module.scss';

export function Targe() {
  return FRONT_ENV !== 'production' ? (
    <div className={styles.ribbonenv}>{FRONT_ENV.toUpperCase()}</div>
  ) : (
    <></>
  );
}
